import { type ConnectionLineComponentProps, getBezierPath, Position } from "@xyflow/react";
import { type FC, memo } from "react";

export const WorkflowConnectionLine: FC<ConnectionLineComponentProps> = memo(function ConnectionLine(props) {
  const { fromX, fromY, fromPosition, toX, toY, toPosition } = props;

  const [edgePath] = getBezierPath({
    sourceX: fromX + (fromPosition === Position.Right ? +10 : -10),
    sourceY: fromY,
    targetX: toX - (fromPosition === Position.Right ? +10 : -10),
    targetY: toY,
    sourcePosition: fromPosition,
    targetPosition: toPosition,
  });

  return (
    <g>
      <path fill="none" stroke="#46769A" strokeWidth={1} className="animated" d={edgePath} />
      <circle cx={toX} cy={toY} fill="#46769A" r={3} stroke="#ffffff" strokeWidth={2} />
    </g>
  );
});
